<template>
  <v-dialog
      v-model="show"
      @click:outside="onClose"
      width="800"
    >
    <v-card>
      <v-card-title class="d-flex justify-end pr-1">
        <v-btn fab absolute x-small text @click="onClose">
          <v-icon x-small >mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="file">
        <div class="h3">{{file.name}}</div>
        <v-img v-if="imgUrl" :src="imgUrl"/>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    file: {
      type: File
    }
  },
  data: () => ({
    show: false,
    imgUrl: undefined,
  }),
  methods: {
    onClose() {
      this.imgUrl = undefined
      this.$emit("update:file", undefined);
    },
    showFile(file) {
      if (file.type.indexOf("image/") == 0) {
        this.showImage(file);
        return;
      }
      this.openFile(file);
    },
    openFile(file) {
      const height = window.height * 0.9;
      const width = window.width * 0.8;
      const win = open('', 'name', 'height='+ height +', width=' + width),
          iframe = document.createElement('iframe'),
          title = document.createElement('title'),
          fileUrl = URL.createObjectURL(file);

      title.appendChild(document.createTextNode(file.name));

      iframe.src = fileUrl;
      iframe.width = '100%';
      iframe.height = '100%';
      iframe.style.border = 'none';

      win.document.head.appendChild(title);
      win.document.body.appendChild(iframe);
      win.document.body.style.margin = 0;
      this.onClose();
    },
    showImage(file) {
      const reader = new FileReader();
      reader.onload = (function() {
        window.imgUrl = reader.result;
        this.imgUrl = reader.result;
      }).bind(this);
      reader.readAsDataURL(file);
      this.show = true;
    }
  },
  watch: {
    file() {
      if (this.file) {
        window.file = this.file;
        this.showFile(this.file);
      }
      else {
        this.show = false;
      }
    }
  }
};
</script>
